// front_end_react_valet/src/homepage/PrivacySmsPolicy.js
import React from "react";
import "./About.css";
import { Link } from "react-router-dom";

const PrivacySmsPolicy = () => {
    return (
        <section className="privacy-policy-page">
            <div className="about-card privacy-policy-inner">
                <h1>SMS Privacy Policy</h1>
                <p className="About-subtitle">Effective Date: April 2026</p>

                <p className="About-text">Park Pilot collects customer contact and vehicle check-in data to provide transactional valet status updates and service-related messaging.</p>

                <h2>1. Information We Collect</h2>
                <p className="About-text">We may collect customer mobile phone number, ticket number, vehicle details (such as color and make), and service activity timestamps related to valet operations.</p>

                <h2>2. How We Use Information</h2>
                <p className="About-text">We use this information to provide valet operational services, including check-in notifications, vehicle status updates, and customer support communication.</p>

                <h2>3. SMS Messaging Program</h2>
                <p className="About-text">SMS messages are transactional service notifications related to valet operations. Message frequency varies by service activity. Message and data rates may apply.</p>

                <h2>4. Consent, Help, and Opt-Out</h2>
                <p className="About-text">By providing a mobile number for valet service updates, users consent to receive transactional SMS messages. Reply HELP for help. Reply STOP to opt out.</p>

                <h2>5. Data Sharing</h2>
                <p className="About-text">We do not sell, rent, or share personal information with third parties for their marketing or promotional purposes.</p>
                <p className="About-text">All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties, affiliates, or partners for marketing or promotional purposes.</p>

                <h2>6. Service Providers</h2>
                <p className="About-text">We may use service providers (such as SMS platform providers) only as needed to deliver operational messaging and support valet service.</p>

                <h2>7. Contact</h2>
                <p className="About-text">For privacy or messaging questions, contact: parkpilotvalet@gmail.com</p>
            </div>
            <div className="about-card">
                <h2>Learn More</h2>
                <p className="About-text">
                    <Link to="/terms">SMS Terms & Conditions</Link>
                </p>
                <p className="About-text">
                    <Link to="/privacy-policy">General Privacy Policy</Link>
                </p>
                <p className="About-text">
                    <Link to="/">Back to Home</Link>
                </p>
            </div>
        </section>
    );
};

export default PrivacySmsPolicy;
